import React from 'react';
import TextArea from 'antd/es/input/TextArea';
import { Note } from 'models/ComunicationHub';
import { ValidationErrors } from 'constants/validations';
import { Col, CommunicationHubEntityType, Form, FormModal, Row, Typography } from 'components';
import { RelationCard } from './relation/RelationCard';
import { RelationForm } from './relation/RelationForm';
import { useNoteAddEdit } from './useNoteAddEdit';
import { AttachmentForm } from './Attachments';

const { Item } = Form;
const { Text } = Typography;

export interface INoteAddUpdateModal {
  entity: CommunicationHubEntityType;
  modalState: boolean;
  onModalStateChange: (value: boolean) => void;
  dataToEdit?: Note;
}

export const NoteAddUpdateModal = (props: INoteAddUpdateModal) => {
  const { modalState, onModalStateChange, dataToEdit, entity } = props;
  const {
    form,
    isLoading,
    relationEdit,
    onFinish,
    onCancel,
    onRelationItemSave,
    onRelationItemCancel,
    onRelationItemRemove,
    onRelationItemEdit,
    attachmentType,
    relations,
    attachments,
    setAttachmentType,
    fileList,
    setFileList,
    disableSaveBtn,
    handleAttachmentChange,
  } = useNoteAddEdit({
    modalState,
    onModalStateChange,
    dataToEdit,
    entity,
  });
  return (
    <FormModal
      form={form}
      title={`${dataToEdit ? 'Update' : 'Add'} Note`}
      width={680}
      okText={dataToEdit ? 'Save' : 'Add'}
      open={modalState}
      isLoading={isLoading}
      onCancel={onCancel}
      onSubmit={onFinish}
      disableOkBtn={disableSaveBtn}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Item name={'note'} label={'Note*'} rules={[{ required: true, message: ValidationErrors.required('Note') }]}>
            <TextArea style={{ resize: 'none' }} rows={4} size={'large'} />
          </Item>
        </Col>
        <Col span={24} className={'margin-t-20'}>
          <Text style={{ color: '#05796B', fontWeight: 800 }}>Attachments</Text>
        </Col>
        <Col span={24}>
          <AttachmentForm
            attachments={attachments}
            setAttachmentType={setAttachmentType}
            fileList={fileList}
            entity={entity}
            setAttachments={handleAttachmentChange}
            setFileList={setFileList}
            attachmentType={attachmentType}
          />
        </Col>
        <Col span={24}>
          <Text style={{ color: '#05796B', fontWeight: 800 }}>Relation</Text>
        </Col>
        {!!relations.length && (
          <Col span={24}>
            <Row gutter={[0, 6]}>
              {relations.map((_relation) => (
                <RelationCard
                  entity={entity}
                  onSave={onRelationItemSave}
                  onCancel={onRelationItemCancel}
                  onRemove={onRelationItemRemove}
                  onEdit={onRelationItemEdit}
                  form={form}
                  data={_relation}
                  key={_relation.relationEntity + _relation.relationType}
                  relationList={relations}
                  isEditeMode={
                    _relation.relationEntity === relationEdit?.entity && _relation.relationType === relationEdit?.type
                  }
                />
              ))}
            </Row>
          </Col>
        )}
        <Col span={24}>
          <RelationForm form={form} onSave={onRelationItemSave} relationList={relations} entity={entity} />
        </Col>
      </Row>
    </FormModal>
  );
};
